<template>
    <div class="text-center">
        
        <v-progress-circular :rotate="360" :size="200" :width="24" :value="totalStorageValue" color="#BDBDBD"
            class="mb-5">
            <h1 style="font-size: 2.5em; color: #616161;">{{ totalStorageValue }}%</h1>
        </v-progress-circular>

        <v-col class="mb-3" v-if="!reference.rp_storage">
            <v-btn icon :color="storageUnit === 'MB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeStorageUnit('M')">
                MB
            </v-btn>
            <v-btn icon :color="storageUnit === 'GB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                class="ml-1 mr-1" @click="changeStorageUnit('G')">
                GB
            </v-btn>
            <v-btn icon :color="storageUnit === 'TB' ? '#006cea' : 'grey'" outlined small style="font-size: 10px;"
                @click="changeStorageUnit('T')">
                TB
            </v-btn>
        </v-col>

        <div class="statistics_sub">
            <h5 v-if="this.startTime" class="mb-2" style="color:#999">{{ this.startTime }} ~ {{ this.endTime }}</h5>
            <span>기준 사용량 {{ totalStorage }} {{ storageUnit }}</span>
        </div>
        
        <h4>사용 {{ usedStorage }} <strong>{{ storageUnit }}</strong></h4>
    </div>
</template>

<script>
import StatisticsApi from "@/api/statistics/StatisticsApi";

export default {
    name: 'StorageTrafficComponent',
    props: ['reference', 'units'],
    data() {
        return {
            OriginalStorageUsage: 0,
            totalStorageValue: '',
            usedStorage: 0,
            startTime: '',
            endTime: '',
            totalStorage: this.reference && this.reference.rp_storage ? this.reference.rp_storage : 1000,
            storageUnit: this.reference && this.reference.rp_unit ? this.reference.rp_unit : 'MB',
        };
    },
    // mounted() {
    //     this.storageUnit = this.reference && this.reference.rp_unit ? this.reference.rp_unit : 'MB';
    //     this.getStorageUsageData();
    // },
    methods: {
        async getStorageUsageData() {
            const response = await StatisticsApi.storageApi();
            if (response.totalSize) {
                this.startTime = response.date.start_time;
                this.endTime = response.date.end_time;

                this.OriginalStorageUsage = parseFloat(response.totalSize).toFixed(2);
                this.usedStorage = this.OriginalStorageUsage;
                this.unitAutoChange();
            } else {
                this.startTime = response.date.start_time;
                this.endTime = response.date.end_time;
                this.usedStorage = "0.00";
                this.totalStorageValue = 0;
            }
        },
        calculatePercentage() {
            let baseTraffic = parseFloat(this.totalStorage);
            let usedStorage = parseFloat(this.usedStorage);
            this.totalStorageValue = ((usedStorage / baseTraffic) * 100).toFixed(1);
        },
        unitAutoChange() {
            const usedStorageInBytes = this.OriginalStorageUsage;
            let usedStorage = usedStorageInBytes / (1000 * 1000);

            if (this.reference && this.reference.rp_unit) {
                switch (this.reference.rp_unit) {
                    case 'TB':
                        usedStorage /= (1000 * 1000);
                        break;
                    case 'GB':
                        usedStorage /= 1000;
                        break;
                }
                this.storageUnit = this.reference.rp_unit;
            } else {
                if (usedStorage > 1000 * 1000) {
                    this.storageUnit = 'TB';
                    usedStorage /= (1000 * 1000);
                } else if (usedStorage > 1000) {
                    this.storageUnit = 'GB';
                    usedStorage /= 1000;
                } else {
                    this.storageUnit = 'MB';
                }
            }
            usedStorage = Math.round(usedStorage * 100) / 100;
            this.usedStorage = usedStorage.toFixed(2);
            this.calculatePercentage();
        },
        changeStorageUnit(units) {

            this.storageUnit = units === 'M' ? 'MB' : units === 'G' ? 'GB' : 'TB';
            let usedMB = this.OriginalStorageUsage / (1000 * 1000);
            switch (units) {
                case 'G': this.usedStorage = (usedMB / 1000).toFixed(2); break;
                case 'T': this.usedStorage = (usedMB / (1000 * 1000)).toFixed(2); break;
                default: this.usedStorage = usedMB.toFixed(2);
            }
            this.calculatePercentage();
        },
        formatDate(date) {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const hh = String(date.getHours()).padStart(2, '0');
            const min = String(date.getMinutes()).padStart(2, '0');
            const ss = String(date.getSeconds()).padStart(2, '0');

            return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
        },
    },
    watch: {
        'reference': {
            deep: true,
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.rp_unit) {
                    this.storageUnit = newVal.rp_unit;
                } else {
                    this.storageUnit = 'MB';
                }

                if (newVal && newVal.rp_storage) {
                    this.totalStorage = newVal.rp_storage;
                } else {
                    this.totalStorage = 1000;
                }
                //this.unitAutoChange();
                this.getStorageUsageData();
            }
        },
    },
};
</script>

<style>
.statistics_sub {
    color: #999;
    font-size: 14px;
}

h4 strong {
    color: #006cea;
}
</style>